import { AgeType } from "public_app/events/entity";
export var PartnershipRegistrationState;
(function (PartnershipRegistrationState) {
    PartnershipRegistrationState[PartnershipRegistrationState["Registration"] = 0] = "Registration";
    PartnershipRegistrationState[PartnershipRegistrationState["Active"] = 1] = "Active";
    PartnershipRegistrationState[PartnershipRegistrationState["Separated"] = 2] = "Separated";
    PartnershipRegistrationState[PartnershipRegistrationState["Rejected"] = 3] = "Rejected";
})(PartnershipRegistrationState || (PartnershipRegistrationState = {}));
export var getPartnershipRegistrationStateValues = function () {
    return [
        PartnershipRegistrationState.Registration,
        PartnershipRegistrationState.Active,
        PartnershipRegistrationState.Separated,
        PartnershipRegistrationState.Rejected,
    ];
};
export var getPartnershipStatusText = function (state) {
    if (state === PartnershipRegistrationState.Registration) {
        return "Čeká na potvrzení";
    }
    if (state === PartnershipRegistrationState.Active) {
        return "Aktivní";
    }
    if (state === PartnershipRegistrationState.Separated) {
        return "Ukončeno";
    }
    if (state === PartnershipRegistrationState.Rejected) {
        return "Zamítnuto";
    }
    return "";
};
export var getPartnershipAgeTypeToShow = function (partnership) {
    if (partnership.rankingAge === AgeType.Adult && ![
        AgeType.Under_8,
        AgeType.Juvenile_I,
        AgeType.Juvenile_II,
        AgeType.Junior_I,
        AgeType.Junior_II,
        AgeType.Youth,
        AgeType.Under_21,
    ].includes(partnership.competitorAge)) {
        return AgeType.Adult;
    }
    return partnership.competitorAge;
};
export var groupPartnershipsByCompetitorId = function (partnershipData) {
    var orderedPartnershipData = partnershipData.filter(function (p) { return true; }).sort(function (a, b) {
        if (a.state !== b.state) {
            return a.state - b.state;
        }
        return b.id - a.id;
    });
    var allCompetitorIds = orderedPartnershipData.map(function (p) { return p.competitorId; });
    var uniqueCompetitorIds = allCompetitorIds.filter(function (c, i) { return allCompetitorIds.indexOf(c) === i; });
    var groupedPartnershipData = uniqueCompetitorIds.map(function (competitorId) {
        var relatedPartnerships = orderedPartnershipData.filter(function (p) { return p.competitorId === competitorId; });
        var partner1 = relatedPartnerships[0].person1;
        var partner2 = relatedPartnerships[0].person2;
        var partnershipRecords = relatedPartnerships.map(function (p) {
            var _a, _b;
            return {
                id: p.id,
                series: p.series,
                discipline: p.discipline,
                rankingAge: p.rankingAge,
                competitorAge: p.competitorAge,
                selectedClass: p.selectedClass,
                state: p.state,
                registrationDate: (_a = p.registrationDate) !== null && _a !== void 0 ? _a : undefined,
                separationDate: (_b = p.separationDate) !== null && _b !== void 0 ? _b : undefined,
            };
        });
        return {
            competitorId: competitorId,
            person1: partner1,
            person2: partner2,
            partnerships: partnershipRecords,
        };
    });
    return groupedPartnershipData;
};
